import { apiClient } from './api-client';
import type { ValidationGate } from '@/types/auth.types';

export const validationGateApi = {
  /** Etat courant de la regle de validation croisee pour l'utilisateur connecte. */
  getMine: async (): Promise<ValidationGate> => {
    const { data } = await apiClient.get('/users/me/validation-gate');
    return data?.data ?? data;
  },
};
